import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * A gizmo for a box with a centre mark: the 12 edges of an AABB and three unit axes from its
 * centre, in one Godot colour, and a faint fill that Godot adds only to a selected gizmo. The
 * caller mounts it in a `PluginGizmo`.
 */
import { useMemo } from 'react';
import { useGodotLinearColor } from '../godotColor';
import { centreAxisLines } from '../gizmo/centreAxes';
import { SelectedOnly } from '../gizmo/PluginGizmo';
import { AabbGizmo } from './AabbGizmo';
import { AabbSolidGizmo } from './AabbSolidGizmo';
import { GizmoLine } from './GizmoLine';
export function AabbAxesGizmo({ aabb, color, solidAlpha }) {
    const axes = useMemo(() => new Float32Array(centreAxisLines(aabb)), [aabb]);
    return (_jsxs(_Fragment, { children: [_jsx(AabbGizmo, { aabb: aabb, color: color }), _jsx(GizmoLine, { positions: axes, color: useGodotLinearColor(color) }), _jsx(SelectedOnly, { children: _jsx(AabbSolidGizmo, { aabb: aabb, color: color, alpha: solidAlpha }) })] }));
}
//# sourceMappingURL=AabbAxesGizmo.js.map